import script from "./ComplaintRiskModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintRiskModal.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintRiskModal.vue?vue&type=style&index=0&id=7f18625e&lang=scss&scoped=true"
import "./ComplaintRiskModal.vue?vue&type=style&index=1&id=7f18625e&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f18625e"]])

export default __exports__